<nav class="settings-nav" [attr.aria-label]="'management.navigation.company.aria' | translate">
	<div class="settings-nav__top">
		<header class="settings-nav__header">
			<button type="button" class="settings-nav__title-button"
				[class.settings-nav__title-button--external]="isExternalCompany()"
				[disabled]="!isExternalCompany()" (click)="resetCompanyContext()">
				@if (isExternalCompany()) {
					{{ currentCompany()?.companyName }}
				} @else {
					{{ 'management.navigation.adminTitle' | translate }}
				}
			</button>
		</header>

		@if (moduleItems().length > 0) {
		<section class="settings-nav__section" [attr.aria-label]="'management.navigation.modules.title' | translate">
			<h3 class="settings-nav__section-title">{{ 'management.navigation.modules.title' | translate }}</h3>
			@for (item of moduleItems(); track item.route) {
				<a class="settings-nav__item settings-nav__item--with-icon" [routerLink]="item.route"
					routerLinkActive="settings-nav__item--active" [routerLinkActiveOptions]="{ exact: true }">
					@if (item.iconClass) { <i [class]="item.iconClass" aria-hidden="true"></i> }
					<span>{{ item.labelKey | translate }}</span>
				</a>
			}
		</section>
		}

		@if (settingsItems().length > 0) {
		<section class="settings-nav__section" [attr.aria-label]="'management.navigation.company.title' | translate">
			<h3 class="settings-nav__section-title">{{ 'management.navigation.company.title' | translate }}</h3>
			@for (item of settingsItems(); track item.route) {
				<a class="settings-nav__item settings-nav__item--with-icon" [routerLink]="item.route"
					routerLinkActive="settings-nav__item--active" [routerLinkActiveOptions]="{ exact: true }">
					@if (item.iconClass) { <i [class]="item.iconClass" aria-hidden="true"></i> }
					<span>{{ item.labelKey | translate }}</span>
				</a>
			}
		</section>
		}
	</div>

	@if (canAccessAdminNavigation()) {
	<button type="button" class="settings-nav__switch" (click)="onAdminRequested()">
		<i class="fa-regular fa-building" aria-hidden="true"></i>
		<span>{{ 'management.navigation.managePlatform' | translate }}</span>
	</button>
	}
</nav>
